
import { useEffect, useState } from "react";

export default function useCatalogue(feedUrl) {
  const [catalogue, setCatalogue] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(feedUrl, { cache: "no-store" });
        if (!res.ok) throw new Error("Failed to load catalogue");
        const data = await res.json();
        if (mounted) setCatalogue(data);
      } catch (e) {
        if (mounted) setError("Could not load catalogue. Check Drive sharing or feed URL.");
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [feedUrl]);

  return { catalogue, loading, error };
}
